export default __webpack_public_path__ + "static/media/numero.d745907c.png";